<template>
	<div class="poplist" @mouseover="show" @mouseleave="hide" ref="poplist">
		<div class="fuze"><slot name="fuze"></slot></div>
		<div class="pop h-center" v-show="isShowed" @click="handleClick" ref="pop"><slot></slot></div>
	</div>
</template>
<script>
	export default {
		name: 'poplist',

		data() {
			return {
				isShowed: false
			}
		},
		methods: {
			handleClick() {
				this.isShowed = false;
			},
			show() {
				var vue = this;
				var poplist = this.$refs.poplist;
				var pop = this.$refs.pop;
				setTimeout(function(){ 
					if ($(poplist).is(':hover'))  vue.isShowed = true;
					$(pop).css({height: $(pop).children().height()})
				}, 150) 
			},
			hide() {
				var vue = this;
				var poplist = this.$refs.poplist;
				var pop = this.$refs.pop;
				setTimeout(function() {
					if(!$(poplist).is(':hover')) vue.isShowed = false
				}, 150)
			}
		},
		mounted() {
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/poplist/poplist.vue